import React, { useCallback, useState } from 'react';
import axios from '../modules/api';
import http from '../modules/api';
import * as StyleUtil from '../modules/utils/StyleUtil';
import {Line} from 'react-chartjs-2';
import { NavLink, Link, Prompt } from 'react-router-dom';
import $ from 'jquery';
import Slider from "react-slick";
import plus_img from '../../resources/img/plus.svg';
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import BasicDialogV2 from '../modules/dialogs/BasicDialogV2';
import CheckBox from '../modules/common/CheckBox';
import Icon from '../modules/common/Icon';
import icn_clone from '../../resources/img/icn_clone.svg';
import {RpCafe24ClonePopup} from './RpCafe24ClonePopup';

import ReactGA, { send } from 'react-ga';
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";

import Pagination from "react-js-pagination";

ReactGA.initialize('UA-78553461-8', {
    titleCase: false,
});

let window_scrollTop; // 스크롤 위치

export class RpEventList_nonInstall extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            // 무료 체험 기간 관련 변수
            remain_date: "",
            start_day_of_week: "",
            start_date_format: "",
            is_finish: "",
            end_day_of_week: "",
            end_date_format: "",
            payment_cls_text: "",
            next_card_payment_yn: "",

            list : [], // 진열 목록
            disabled_del_list : [], // 삭제 불가능한 진열 목록
            checked_rp_list: [], // 선택된 진열 목록
            is_cafe24: "",
            tutorial_dialog_state : false,
            param_iframe_page_id : "",

            // 노출 여부 관련 다이얼로그
            confirm_dialog_show_state : false, // 노출 여부 변경 물어보기
            confirm_dialog_content: "",
            confirm_dialog_button_list: [],
            basic_dialog_show_state : false, // 노출 여부 변경 확인
            basic_dialog_content: "",
            basic_dialog_button_list: [],
            delete_dialog_show_state : false, // 삭제 여부 물어보기
            delete_dialog_content: "",
            delete_dialog_button_list: [],
            notice_period_title_content_dialog_show_state : false,
            title_content_dialog_title: "",
            title_content_dialog_content: "",
            title_content_dialog_button_list: [],
            notice_delete_dialog_show_state : false, // 비활성화 삭제 버튼 클릭시 알림
            notice_delete_dialog_content: "",
            notice_delete_dialog_button_list: [],
            notice_period_banner_show_state: false, // 진열 이용기간 상단 배너 노출

            showClonePopup: false,
            targetCloneObj: null,

            tooltipVisible: false,
            tooltipX: 0,
            tooltipY: 0,

            /** 전체 수 */
            totalCnt : 0,
            /** 페이징의 페이지 번호 (하단에 페이징 버튼과 직결) */
            activePage: 1,
            /** 페이징시 시작 수 */
            start_idx: 0,
            /** 페이징시 화면에 나올 수 */
		    row_cnt: 20,

            search_by_title: "",
        }
    }

    componentWillMount() {

    }

	componentDidMount() {
        $(document).ready(function(){
            // 왼쪽 네비바 닫혀있는 경우 열기
            $(".menu_expansion_arrow.cursor-pointer").trigger('click');

            //table의 넓이 계산
            var list_td = document.getElementsByClassName("list_td");
            var list_td_sum = 0;
            
            for(let i = 0; i < list_td.length; i++){
                list_td_sum = list_td_sum + list_td[i].offsetWidth;
            }

            $(".list_home_main_row_3 table").css({
                "width":list_td_sum
            });
        });

        this.loadFreeDatePeriod(true);
        this.loadRpEventEventSetting(true);

        // 진열 이용기간 상단 배너
        if(sessionStorage.getItem("RP_LIST_OPERATION_BANNER") == "close" || this.getCookie("RP_LIST_OPERATION_BANNER") == "true"){
            this.setState({
                notice_period_banner_show_state: false
            });
            $(".list_home_main_banner").hide();
        }else{
            this.setState({
                notice_period_banner_show_state: true
            });
            $(".list_home_main_banner").show();
        }
    }

    componentDidUpdate() {
    }

    componentWillUnmount(e) {

    }

    // 진열 이용기간 다이얼로그
    loadRpPeriodDialog() {
        if(this.getCookie("RP_LIST_OPERATION_DIALOG")){
            this.setState({
                notice_period_title_content_dialog_show_state: false
            });
        }else{
            if(this.state.is_finish == 0) {
                if(this.state.remain_date > 10) {
                    this.setState({
                        notice_period_title_content_dialog_show_state: false
                    });
                }else{
                    this.showRpPeriodDialog();
                }

            }else {
                this.showRpPeriodDialog();
            }
        }
    }

    // 진열 이용기간 다이얼로그
    showRpPeriodDialog () {
        this.setState({
            notice_period_title_content_dialog_show_state: true,
            title_content_dialog_button_list: [
                {
                    title: "기간 연장하기",
                    type: "1",
                    event_method: () => {
                        this.setState({
                            notice_period_title_content_dialog_show_state : false,
                        }, () => {
                            this.onClicExtendPeriod();
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        });
                    }
                },
                {
                    title: "3일동안 보지 않기",
                    type: "0",
                    event_method: () => {
                        this.setState({
                            notice_period_title_content_dialog_show_state: false,
                        }, () => {
                            this.setCookie("RP_LIST_OPERATION_DIALOG", true, 3);
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        });
                    }
                }
            ]
        });
    }

    // 상단 배너 하루동안 보지않기 버튼 클릭
    handleDontShowBannerBtnOnClick () {
        this.setState({
            notice_period_banner_show_state: false,
        }, () => {
            this.setCookie("RP_LIST_OPERATION_BANNER", true, 1);
        });
        $(".list_home_main_banner").hide();
    }

    // 상단 배너 닫기 버튼 클릭
    handleCloseBannerBtnOnClick () {
        this.setState({
            notice_period_banner_show_state: false,
        }, () => {
            sessionStorage.setItem("RP_LIST_OPERATION_BANNER", "close");
        });
        $(".list_home_main_banner").hide();
    }

    setCookie(name, value, day) {
        var date = new Date();
        date.setTime(date.getTime() + day * 60 * 60 * 24 * 1000);
        document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    };

    getCookie(name) {
        var value =document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return value? value[2] : null;
    };

    setGaEvent(action_text) {
        ReactGA.event({
             category: "베스트 서비스 (롤링 목록)",
             action: action_text,
             label: sessionStorage.getItem("user_id"),
         });
    }

    // 무료 체험 기간 조회
    async loadFreeDatePeriod(first_load){
        await http.get("/rest/shop/rp/freeDatePeriod")
		.then(res => {
            // console.log(res.data);
			if (res.data != null && res.data != '') {
                let start_date = res.data["start_date_format"];
                start_date = start_date.replace("년","-");
                start_date = start_date.replace("월","-");
                start_date = start_date.replace("일","");
                start_date = start_date.replace(/ /gi,"");

                let end_date = res.data["end_date_format"];
                end_date = end_date.replace("년","-");
                end_date = end_date.replace("월","-");
                end_date = end_date.replace("일","");
                end_date = end_date.replace(/ /gi,"");

                let payment_yn = res.data["payment_yn"];
                let payment_cls_text = "";
                if (payment_yn == 'Y') {
                    payment_cls_text = "멤버십";
                } else {
                    payment_cls_text = "무료 체험";
                }

				this.setState({
                    remain_date: res.data["remain_date"],
                    start_day_of_week: res.data["start_day_of_week"],
                    start_date_format: start_date,
                    is_finish: res.data["is_finish"],
                    end_day_of_week: res.data["end_day_of_week"],
                    end_date_format: end_date,
                    payment_yn: res.data["payment_yn"],
                    payment_cls_text: payment_cls_text,
                    next_card_payment_yn: res.data["next_card_payment_yn"],
                });

                if(first_load && res.data["next_card_payment_yn"] != "Y") {
                    // 진열 이용기간 다이얼로그
                    this.loadRpPeriodDialog();
                }
			}
		})
		.catch(error => {
		 });
    }
    
    // 진열 목록 데이터 불러오기
    async loadRpEventEventSetting(first_load) {
        let param_iframe_page_id = this.state.param_iframe_page_id;
        let cafe24_category_display_group = "";
        if (this.state.param_iframe_page_id.indexOf("/") >= 0) {
            param_iframe_page_id = this.state.param_iframe_page_id.split("/")[0];
            cafe24_category_display_group = this.state.param_iframe_page_id.split("/")[1];
        }

        this.setState({
            list : [],
            checked_rp_list: [],
        }, async () => {
            await http.get("/rest/shop/rp/list/event/setting/v3?is_cafe24=Y&param_iframe_page_id="+param_iframe_page_id+"&cafe24_category_display_group="+cafe24_category_display_group+"&start_idx="+this.state.start_idx+"&row_cnt="+this.state.row_cnt+"&search_by_title="+encodeURIComponent(this.state.search_by_title))
            .then(res => {
                // console.log(res.data);
                if (res.data != null && res.data != '') {
                    let list = res.data["list"];
                    let disabled_del_list = []; // 수량 체크용
                    
                    /* 카페24 진열은 결제 중에도 삭제 할 수 허용 (주석처리) */
                    // for(var idx in list){
                    //     // 결제중인 경우에는 삭제가 불가능하다.
                    //     if(list[idx].pay_operated_yn == "Y"){
                    //         disabled_del_list.push(list[idx]);
                    //         list[idx].disabled_del = true;
                    //     }
                    // }
                    
                    this.setState({
                        list : list,
                        disabled_del_list : disabled_del_list,
                        is_cafe24 : "Y",
                        totalCnt : res.data["totalCnt"] || 0,
                    });
    
                    // if(first_load && list.length === 0){
                    //     window_scrollTop = StyleUtil.onPopupNoneScroll();
                    //     this.setState({
                    //         tutorial_dialog_state : true,
                    //     });
                    // }
                }
            })
            .catch(error => {
             });
        });
    }

    // 진열 상세 페이지로 이동
    onClickRpProductPageLink(idx, obj) {
        const {list} = this.state;
        // console.log(this.state.is_finish + " / " + list[idx].operateed_yn);
        // return 0;

        // 이용중일 때만 상세 페이지로 이동 가능
        if(obj.operateed_yn === "Y"){
            this.setGaEvent("목록 클릭 - "+ list[idx].display_name);
            this.props.history.push(
                {
                    pathname: `/shop/rp/event/product/cafe24List`,
                    search:`?page_id=`+list[idx].iframe_page_id+`&html_id=`+list[idx].iframe_html_id,
                }	
            )
        } else{
            window_scrollTop = StyleUtil.onPopupNoneScroll();
        
            this.setState({
                basic_dialog_show_state: true,
                basic_dialog_content: "이용 기간이 종료되었습니다.",
                basic_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            //팝업 닫기
                            this.setState({ basic_dialog_show_state: false });
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }
                    }
                ]
            });
        }
    }

    // 기간 연장하기
    onClicExtendPeriod(){
        this.props.history.push(
            {
                pathname: `/shop/qna/form`,
                state: {qna_type_cd: "2104"}
            }	
        )
    }

    // 사용자 가이드
    onClickUserGuide(){
        window.open("https://robomd.notion.site/MD-afd2193359e04feabd3966f767a035e2");
    }

    // cafe24 메인 진열 등록 페이지로 이동
    addMainList(e){
        this.setGaEvent("메인 진열 등록 클릭");
        this.props.history.push(
            {
                pathname: `/shop/rp/event/product/cafe24List/16006`
            }
        )
    }

    // cafe24 카테고리 진열 등록 페이지로 이동
    addCategoryList(e){
        this.setGaEvent("카테고리 진열 등록 클릭");
        this.props.history.push(
            {
                pathname: `/shop/rp/event/product/cafe24List/16009`
            }
        )
    }

    // 진열 목록 전체 선택
    checkAllRpEventListOnChange(e) {
        const {list} = this.state;
        let checked_rp_list = [];

        if (e.target.checked) {
            for(var idx in list) {
                // 결제중인 경우에는 삭제(체크)가 불가능하다.
                if(!list[idx].disabled_del){
                    checked_rp_list.push(list[idx]);
                }
            }
        }

        this.setState({
            checked_rp_list: checked_rp_list,
        });
    }

    // 진열 목록 개별 선택
    checkOneRpEventListOnChange(e) {
        const {list, checked_rp_list} = this.state;
        let idx = e.target.value;

        if(e.target.checked) {
            checked_rp_list.push(list[idx]);
        }else{
            for(var rp in checked_rp_list) {
                if(checked_rp_list[rp].iframe_page_id == list[idx].iframe_page_id && checked_rp_list[rp].iframe_html_id == list[idx].iframe_html_id){
                    checked_rp_list.splice(rp, 1);
                    break;
                }
            }
        }

        this.setState({
            checked_rp_list: checked_rp_list,
        });
    }

    // 진열 목록 다중 삭제
    deleteMultiRpEventListOnClick(e) {
        const {list, checked_rp_list, is_cafe24} = this.state;
        let delete_rp_list = [];

        if(checked_rp_list != null && checked_rp_list.length > 0){
            checked_rp_list.map((obj) => {
                delete_rp_list.push(obj);
            });
        }

        for(var idx in delete_rp_list){
            console.log(delete_rp_list[idx])
        }

        const config = {
            headers: {'Content-Type': 'application/json'}
        };
        const url = '/rest/shop/rp/event/list/delete';
        const body = {
            is_cafe24 : is_cafe24,
            list : delete_rp_list
        };

        if (delete_rp_list != null && delete_rp_list.length > 0) {
            this.setState({
                delete_dialog_show_state: true,
                delete_dialog_content: "선택하신 진열을 삭제하시겠습니까?",
                delete_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            http
                                .post(url, body, config)
                                .then((res) => {
                                    if (res.data.code == "200") {
                                        this.setState({
                                            delete_dialog_show_state: false,
                                            checked_rp_list: [],
                                        }, () => {
                                            this.setState({
                                                basic_dialog_show_state : true,
                                                basic_dialog_content: "삭제가 완료되었습니다.",
                                                basic_dialog_button_list: [
                                                    {
                                                        title: "확인",
                                                        type: "1",
                                                        event_method: () => {
                                                            //팝업 닫기
                                                            this.setState({ basic_dialog_show_state: false });
                                                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                                        }
                                                    }
                                                ],
                                            });

                                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                            this.loadFreeDatePeriod();
                                            this.loadRpEventEventSetting();

                                        });

                                    } else if (res.data.code == "400" || res.data.code == "500") {
                                        alert(res.data.msg);
                                        this.setState({
                                            delete_dialog_show_state: false
                                        });

                                    } else {
                                        alert("삭제에 실패하였습니다.");
                                        this.setState({
                                            delete_dialog_show_state: false
                                        });
                                    }
                                })
                                .catch((error) => {
                                    alert("삭제에 실패하였습니다.");
                                    this.setState({
                                        delete_dialog_show_state: false
                                    });
                                    console.log(error);
                                });
                        }
                    },
                    {
                        title: "취소",
                        type: "0",
                        event_method: () => {
                            this.setState({
                                delete_dialog_show_state: false
                            });
                        }
                    }
                ]
            });
        }else {
            alert("삭제할 진열을 선택해주세요.");
        }
    }

    // 진열 목록 개별 삭제
    deleteOneRpEventListOnClick(e, obj) {
        const {is_cafe24} = this.state;
        let iframe_page_id = obj.iframe_page_id;
        let iframe_html_id = obj.iframe_html_id;

        console.log("iframe_page_id: " + iframe_page_id)
        console.log("iframe_html_id: " + iframe_html_id)

        const config = {
            headers: {'Content-Type': 'application/json'}
        };
        const url = '/rest/shop/rp/event/delete';
        const body = {
            is_cafe24 : is_cafe24,
            iframe_page_id : iframe_page_id,
            iframe_html_id : iframe_html_id
        };

        if (iframe_page_id != null && iframe_page_id != "" && iframe_html_id != null && iframe_html_id != "") {
            this.setState({
                delete_dialog_show_state: true,
                delete_dialog_content: "이 진열을 삭제하시겠습니까?",
                delete_dialog_button_list: [
                    {
                        title: "확인",
                        type: "1",
                        event_method: () => {
                            http
                                .post(url, body, config)
                                .then((res) => {
                                    if (res.data.code == "200") {
                                        this.setState({
                                            delete_dialog_show_state: false,
                                            checked_rp_list: [],
                                        }, () => {
                                            this.setState({
                                                basic_dialog_show_state : true,
                                                basic_dialog_content: "삭제가 완료되었습니다.",
                                                basic_dialog_button_list: [
                                                    {
                                                        title: "확인",
                                                        type: "1",
                                                        event_method: () => {
                                                            //팝업 닫기
                                                            this.setState({ basic_dialog_show_state: false });
                                                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                                        }
                                                    }
                                                ],
                                            });

                                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                            this.loadFreeDatePeriod();
                                            this.loadRpEventEventSetting();
                                        });

                                    } else if (res.data.code == "405" || res.data.code == "400") {
                                        alert(res.data.msg);
                                        this.setState({
                                            delete_dialog_show_state: false
                                        });

                                    } else {
                                        alert("삭제에 실패하였습니다.");
                                        this.setState({
                                            delete_dialog_show_state: false
                                        });
                                    }
                                })
                                .catch((error) => {
                                    alert("삭제에 실패하였습니다.");
                                    this.setState({
                                        delete_dialog_show_state: false
                                    });
                                });
                        }
                    },
                    {
                        title: "취소",
                        type: "0",
                        event_method: () => {
                            this.setState({
                                delete_dialog_show_state: false
                            });
                        }
                    }
                ]
            });
        }
    }

    // 비활성화 삭제 버튼 클릭시 알림
    noticeDeleteRpEventListOnClick() {
        this.setState({
            notice_delete_dialog_show_state : true,
            notice_delete_dialog_content: "결제이용중인 진열은 삭제할 수 없습니다.<br/>삭제를 원하시는 경우, 문의하기 버튼을 눌러주세요.",
            notice_delete_dialog_button_list: [
                {
                    title: "문의하기",
                    type: "1",
                    event_method: () => {
                        this.props.history.push(
                            {
                                pathname: `/shop/qna/form`
                            }
                        )
                        StyleUtil.clearPopupNoneScroll(window_scrollTop);
                    }
                },
                {
                    title: "닫기",
                    type: "0",
                    event_method: () => {
                        this.setState({
                            notice_delete_dialog_show_state: false,
                        });
                        StyleUtil.clearPopupNoneScroll(window_scrollTop);
                    }
                }
            ],
        });
    }

    renderDaliyStandardAutoDisplay(obj) {
        return (
            <>  
                <div>일별</div>
                {
                    obj.event_cycle
                    ? <div>{obj.event_cycle+"일 마다"}</div>
                    : null
                }
                {
                    obj.event_time
                    ? <div>{obj.event_time+"시에"}</div>
                    : null
                }
                {
                    obj.next_auto_run_date
                    ? <div>{"예약일 " + obj.next_auto_run_date}</div>
                    : null
                }
            </>
        )
    }

    renderWeeklyStandardAutoDisplay(obj) {
        return (
            <>
                <div>요일별</div>
                {
                    obj.weekday_list
                    ? <div>
                        {
                            obj.weekday_list.split(",").length == 7 
                            ? 
                                "전체요일 마다"
                            : 
                                obj.weekday_list
                                .replaceAll(",", "/")
                                .replace("0", "월")
                                .replace("1", "화")
                                .replace("2", "수")
                                .replace("3", "목")
                                .replace("4", "금")
                                .replace("5", "토")
                                .replace("6", "일")
                                +" 마다"
                        }
                        </div>
                    : null
                }
                {
                    obj.event_time
                    ? <div>{obj.event_time+"시에"}</div>
                    : null
                }
            </>
        )
    }

    renderRealTimeStandardAutoDisplay(obj) {
        return (
            <>
                <div>실시간</div>
                {
                    obj.weekday_list
                    ? <div>
                        {
                            obj.weekday_list.split(",").length == 7 
                            ? 
                                "전체요일 마다" 
                            : 
                                obj.weekday_list
                                .replaceAll(",", "/")
                                .replace("0", "월")
                                .replace("1", "화")
                                .replace("2", "수")
                                .replace("3", "목")
                                .replace("4", "금")
                                .replace("5", "토")
                                .replace("6", "일")
                                +" 마다"
                        }
                        </div>
                    : null
                }
                {
                    obj.real_time_cycle
                    ? <div>
                        {
                            Number(obj.real_time_cycle) < 60
                            ? obj.real_time_cycle+"분 마다"
                            :  (() => {
                                const hours = Math.floor(obj.real_time_cycle / 60);
                                const minutes = obj.real_time_cycle % 60;
                                return minutes === 0 
                                  ? `${hours}시간 마다` 
                                  : `${hours}시간 ${minutes}분 마다`;
                              })()
                        }
                        </div>
                    : null
                }
                {
                    obj.real_time_start_hour && obj.real_time_end_hour
                    ? <div>
                        {
                           obj.real_time_start_hour+"시~"+obj.real_time_end_hour+"시까지"
                        }
                        </div>
                    : null
                }
            </>
        )
    }

    renderReservationStandardAutoDisplay(obj) {
        return (
            <>
                <div>수동상품목록</div>
                {
                    obj.reservation_date && obj.reservation_hour
                    ? <div>
                        {
                           "예약일 "+obj.reservation_date+" "+obj.reservation_hour.toString().padStart(2, '0')+":00"
                        }
                        </div>
                    : null
                }
            </>
        )
    }

    onCliclFilter(name) {
        this.setState({
            param_iframe_page_id: name,
            activePage: 1,
            start_idx: 0,
        }, () => {
            this.loadRpEventEventSetting();
        })
    }

    handlePageChange(pageNumber) {

		this.setState({
            activePage: pageNumber,
            start_idx : (pageNumber-1) * this.state.row_cnt,
        }, () => {
            this.loadRpEventEventSetting();
        });
    }

    render() {
        return (
            <>
                <div id='common-page-wrapper' class="style_guide_v2">
                    <div id="list_wrap">
                        {
                            this.state.next_card_payment_yn == "N" /* 다음달 카드 결제 대상이 아닌 경우 */
                            && <div className="list_home_main_banner">
                                <div className="txt_banner_wrap">
                                    <span className="i_notice_banner">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                            <path
                                                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                        </svg>
                                    </span>
                                    <h3 className="text_extrasmall txt_banner_1" style={{marginBottom: 0}}>
                                        {this.state.is_finish == 0 ? this.state.remain_date + "일 뒤 " + this.state.payment_cls_text + "이 종료됩니다. " : this.state.payment_cls_text + "이 종료되었습니다. "}
                                    </h3>
                                    <h3 className="text_extrasmall txt_banner_2">
                                        ({this.state.payment_cls_text} 기간
                                        : {this.state.start_date_format} ~ {this.state.end_date_format})
                                    </h3>
                                    <div className="wrap_btn_period_banner">
                                        <button className="btn_period_banner" onClick={() => this.onClicExtendPeriod()}>기간 연장하기</button>
                                        <button className="btn_period_banner" onClick={() => this.handleDontShowBannerBtnOnClick()}>하루동안 보지 않기</button>
                                    </div>
                                    <button className="btn_close_banner" onClick={() => this.handleCloseBannerBtnOnClick()}>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.2847 14.2158C15.4255 14.358 15.5045 14.5501 15.5045 14.7502C15.5045 14.9504 15.4255 15.1424 15.2847 15.2846C15.1413 15.4232 14.9497 15.5007 14.7503 15.5007C14.5509 15.5007 14.3593 15.4232 14.2159 15.2846L8.00031 9.05959L1.78469 15.2846C1.64133 15.4232 1.44972 15.5007 1.25031 15.5007C1.0509 15.5007 0.859293 15.4232 0.715938 15.2846C0.575101 15.1424 0.496094 14.9504 0.496094 14.7502C0.496094 14.5501 0.575101 14.358 0.715938 14.2158L6.94094 8.00022L0.715938 1.78459C0.59634 1.63887 0.535221 1.45387 0.544469 1.26558C0.553717 1.07729 0.632669 0.899174 0.76597 0.765873C0.899272 0.632572 1.07739 0.553619 1.26568 0.544372C1.45397 0.535124 1.63897 0.596243 1.78469 0.715841L8.00031 6.94084L14.2159 0.715841C14.3617 0.596243 14.5467 0.535124 14.7349 0.544372C14.9232 0.553619 15.1014 0.632572 15.2347 0.765873C15.368 0.899174 15.4469 1.07729 15.4562 1.26558C15.4654 1.45387 15.4043 1.63887 15.2847 1.78459L9.05969 8.00022L15.2847 14.2158Z" fill="#333333"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        }
                        <section className="list_home_main list_home_main_cafe24">
                            <div className="list_home_main_row_1">
                                <h2 className="text_regular">Cafe24 진열 목록</h2>
                            </div>
                            <div className="list_home_main_row_1" style={{gap:"10px", marginTop:"3px"}}>
                                <div className='flexBox' style={{gap:10}}>
                                    <div className="algorithm_filter_area_v2">
                                        <div className={this.state.param_iframe_page_id == "" ? "active" : ""}
                                            onClick={() => {
                                                this.onCliclFilter("");
                                            }
                                        }>전체</div>
                                        <div className={this.state.param_iframe_page_id == "robomd_cafe24_main_page" ? "active" : ""}
                                            onClick={() => {
                                                this.onCliclFilter("robomd_cafe24_main_page");
                                            }
                                        }>메인</div>
                                        <div className={this.state.param_iframe_page_id == "robomd_cafe24_category_page/1" ? "active" : ""}
                                            style={{width: "100px"}}
                                            onClick={() => {
                                                this.onCliclFilter("robomd_cafe24_category_page/1");
                                            }
                                        }>카테고리(일반)</div>
                                        <div className={this.state.param_iframe_page_id == "robomd_cafe24_category_page/2" ? "active" : ""}
                                            style={{width: "100px"}}
                                            onClick={() => {
                                                this.onCliclFilter("robomd_cafe24_category_page/2");
                                            }
                                        }>카테고리(추천)</div>
                                        <div className={this.state.param_iframe_page_id == "robomd_cafe24_category_page/3" ? "active" : ""}
                                            style={{width: "100px"}}
                                            onClick={() => {
                                                this.onCliclFilter("robomd_cafe24_category_page/3");
                                            }
                                        }>카테고리(신상)</div>
                                    </div>
                                    <div className="search_box_rp_event_list">
                                        <input type="text" 
                                            id="search-by-title" 
                                            placeholder="진열 제목으로 검색해 보세요." 
                                            value={this.state.search_by_title}
                                            onChange={e => this.setState({search_by_title: e.target.value})}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter') {
                                                    this.setState({
                                                        activePage: 1,
                                                        start_idx: 0,
                                                    }, () => {
                                                        this.loadRpEventEventSetting();
                                                    });
                                                }
                                            }}
                                        ></input>
                                        <button onClick={() => {
                                            this.setState({
                                                activePage: 1,
                                                start_idx: 0,
                                            }, () => {
                                                this.loadRpEventEventSetting();
                                            });
                                        }}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.9453 17.0547L14.5625 13.6797C15.7564 12.2583 16.3555 10.4308 16.2348 8.57844C16.114 6.72607 15.2828 4.99182 13.9146 3.73738C12.5463 2.48294 10.7465 1.80518 8.89063 1.84545C7.03477 1.88571 5.2661 2.6409 3.9535 3.9535C2.6409 5.2661 1.88571 7.03477 1.84545 8.89063C1.80518 10.7465 2.48294 12.5463 3.73738 13.9146C4.99182 15.2828 6.72607 16.114 8.57844 16.2348C10.4308 16.3555 12.2583 15.7564 13.6797 14.5625L17.0547 17.9453C17.1741 18.0608 17.3338 18.1254 17.5 18.1254C17.6662 18.1254 17.8258 18.0608 17.9453 17.9453C18.0627 17.8268 18.1285 17.6668 18.1285 17.5C18.1285 17.3332 18.0627 17.1732 17.9453 17.0547ZM3.125 9.0625C3.125 7.88817 3.47323 6.74022 4.12565 5.7638C4.77807 4.78738 5.70538 4.02636 6.79032 3.57696C7.87525 3.12757 9.06909 3.00999 10.2208 3.23909C11.3726 3.46819 12.4306 4.03368 13.2609 4.86405C14.0913 5.69443 14.6568 6.75239 14.8859 7.90415C15.115 9.05591 14.9974 10.2497 14.548 11.3347C14.0986 12.4196 13.3376 13.3469 12.3612 13.9993C11.3848 14.6518 10.2368 15 9.0625 15C7.48841 14.9979 5.97938 14.3717 4.86634 13.2587C3.75329 12.1456 3.12707 10.6366 3.125 9.0625Z" fill="#cccccc"></path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className="wrap_list_btn_del_rp">
                                    {/*<button className="list_btn_1 hover_lightmint" onClick={() => this.onClickUserGuide()}>사용자 가이드</button>*/}
                                    <button className="list_btn_del_rp" onClick={() => this.deleteMultiRpEventListOnClick()}>진열 삭제</button>
                                    <button className="list_btn_1 hover_mint add_main_list" onClick={e => this.addMainList(e)} >
                                        <img src={plus_img} alt="더하기 아이콘"/>메인 진열 등록
                                    </button>
                                    <button className="list_btn_1 hover_mint add_category_list" onClick={e => this.addCategoryList(e)} >
                                        <img src={plus_img} alt="더하기 아이콘"/>카테고리 진열 등록
                                    </button>
                                </div>
                            </div>
                            {/*<div className="list_home_main_row_2">*/}
                            {/*    <div>*/}
                            {/*        <span class="i_notice">*/}
                            {/*            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">*/}
                            {/*                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>*/}
                            {/*            </svg>*/}
                            {/*        </span>*/}
                            {/*        <h3 className="text_extrasmall" style={{marginBottom : 0}}>*/}
                            {/*            { this.state.is_finish == 0 ? this.state.remain_date+"일 뒤 "+this.state.payment_cls_text+"이 종료됩니다. " : this.state.payment_cls_text+"이 종료되었습니다. " }*/}
                            {/*            <br/>*/}
                            {/*            ({this.state.payment_cls_text} 기간 : {this.state.start_date_format} ~ {this.state.end_date_format})*/}
                            {/*        </h3>*/}
                            {/*    </div>*/}
                            {/*    <button className="list_btn_2 hover_dark" onClick={() => this.onClicExtendPeriod()}>*/}
                            {/*        기간 연장하기*/}
                            {/*    </button>*/}
                            {/*</div>*/}
                            <div className="list_home_main_row_3 cafe24_rp_list">
                                <table>
                                    <thead>
                                        <tr>
                                            <td className="list_td">
                                                <CheckBox
                                                    id={"list_home_main_checkbox_all"}
                                                    checked={this.state.checked_rp_list.length > 0 && ((this.state.checked_rp_list.length + this.state.disabled_del_list.length) == this.state.list.length)}
                                                    onChangeCheck={this.checkAllRpEventListOnChange.bind(this)}
                                                />
                                            </td>
                                            <td className="list_td">번호</td>
                                            <td className="list_td">진열 복사</td>
                                            <td className="list_td">페이지</td>
                                            <td className="list_td">진열위치</td>
                                            <td className="list_td">진열 제목</td>
                                            <td className="list_td">진열 변경일</td>
                                            <td className="list_td">자동변경 예약일정</td>
                                            <td className="list_td">동작방식</td>
                                            <td className="list_td">설정상품수</td>
                                            <td className="list_td">변경상품수</td>
                                            <td className="list_td">등록일</td>
                                            {/* <td className="list_td">이용 상태</td> */}
                                            {/* <td className="list_td">진열 삭제</td> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { this.state.list != null && this.state.list.length > 0
                                        ?   <>
                                            {
                                                this.state.list.map((obj, idx) => (
                                                    <tr key={obj.iframe_page_id+'_'+obj.iframe_html_id}>
                                                        <td>
                                                            <CheckBox
                                                                id={"list_home_main_checkbox_" + (Number(idx))}
                                                                value={idx}
                                                                checked={this.state.checked_rp_list.find(rp => rp.iframe_page_id == obj.iframe_page_id && rp.iframe_html_id == obj.iframe_html_id) != null}
                                                                disabled={obj.disabled_del}
                                                                onChangeCheck={obj.disabled_del ? null : this.checkOneRpEventListOnChange.bind(this)}
                                                            />
                                                        </td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{(this.state.totalCnt-(idx+(this.state.row_cnt*(this.state.activePage-1))))}</td>
                                                        <td>
                                                        <button 
                                                            onClick={() => this.setState({ showClonePopup: true, targetCloneObj: obj })}
                                                        >
                                                            <Icon className={"btn_clone_auto_event"} text={"진열 복사"} children={<img src={icn_clone} alt={"진열 복사"}/>} onClick={(e) => {this.cloneRpEventListOnClick(e, obj)}}>
															</Icon>
                                                            {/* <img src="/static/media/icn_clone.36ef2ac6.svg" alt="진열 복제"/> */}
                                                            {/* <Tooltip iconWidth={24} iconHeight={24} content={"진열 복사"} hoverSvg={<img src="/static/media/icn_clone.36ef2ac6.svg" alt="진열 복사"/>} nonHoverSvg={<img src="/static/media/icn_clone.36ef2ac6.svg" alt="진열 복제"/>}/> */}
                                                        </button>
                                                        </td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{
                                                        obj.iframe_page_id != "robomd_cafe24_category_page" 
                                                        ? obj.iframe_page_simple_name 
                                                        : obj.iframe_page_simple_name
                                                            +   (obj.cafe24_category_display_group == "1" 
                                                                ? " (일반)"
                                                                : obj.cafe24_category_display_group == "2" 
                                                                    ? " (추천)"
                                                                    : obj.cafe24_category_display_group == "3" 
                                                                        ? " (신상)" 
                                                                        : "")
                                                        }</td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{obj.cafe24_display_name}</td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}><span>{obj.display_name}</span></td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{obj.last_mod_date}</td>

                                                        <td className="rp_standard_auto_display " onClick={() => this.onClickRpProductPageLink(idx, obj)}>
                                                            {
                                                                obj.auto_create_yn == "Y"
                                                                ?   obj.event_cycle_type == "A8001" 
                                                                    ?   // 일별
                                                                        this.renderDaliyStandardAutoDisplay(obj)
                                                                    :   obj.event_cycle_type == "A8002"
                                                                        ?   this.renderWeeklyStandardAutoDisplay(obj)
                                                                        :   obj.event_cycle_type == "A8003"
                                                                            ?   this.renderRealTimeStandardAutoDisplay(obj)
                                                                            :   // 일별
                                                                                this.renderDaliyStandardAutoDisplay(obj)
                                                                :   obj.reservation_use_yn == "Y"
                                                                    ?   this.renderReservationStandardAutoDisplay(obj)
                                                                    :   null          
                                                            }
                                                        </td>
                                                        
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{obj.auto_create_yn_name}</td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{obj.product_cnt}</td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{obj.last_event_product_cnt}</td>
                                                        <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>{obj.reg_date}</td>
                                                        {/* {obj.pay_operated_yn === "Y" ?
                                                            <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>
                                                                <font style={{textAlign:"center", color:"#10CFC9"}}>결제 이용 중</font>
                                                            </td>
                                                            :
                                                            obj.free_operated_yn === "Y" ?
                                                                <td onClick={() => this.onClickRpProductPageLink(idx, obj)}>
                                                                    <font style={{textAlign:"center", color:"#10CFC9"}}>무료 체험 중</font>
                                                                </td>
                                                                :
                                                                obj.request_type == null ?
                                                                    <td>
                                                                        <font style={{textAlign:"center", color:"#B7BDC3"}}>무료 체험 종료</font>
                                                                    </td>
                                                                    :
                                                                    <td>
                                                                        <font style={{textAlign:"center", color:"#B7BDC3"}}>{obj.code_name}</font>
                                                                    </td>
                                                        } */}
                                                        {/* <td>
                                                            {obj.disabled_del
                                                            ?   <button className="btn_del_rp_disabled" onClick={(e) => {this.noticeDeleteRpEventListOnClick()}}>삭제</button>
                                                            :   <button className="btn_del_rp" onClick={(e) => {this.deleteOneRpEventListOnClick(e, obj)}}>삭제</button>
                                                            }
                                                        </td> */}
                                                    </tr>
                                                ))
                                            }
                                            </>
                                        :
                                            ""
                                        }
                                    </tbody>
                                </table>
                            </div>
                            {
                                Number(this.state.totalCnt) > 0
                                ?
                                <div class="common_pagination" style={{
                                        maxWidth: '100%', 
                                        justifyContent: 'center', 
                                        display: "flex",
                                        flexDirection: "row",
                                        margin: "20px auto 20px auto",
                                }}>
                                    <Pagination
                                        firstPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.35627 13.3562C8.26147 13.4501 8.13344 13.5028 8.00002 13.5028C7.8666 13.5028 7.73857 13.4501 7.64377 13.3562L2.64377 8.35623C2.55136 8.26066 2.4997 8.13292 2.4997 7.99998C2.4997 7.86704 2.55136 7.7393 2.64377 7.64373L7.64377 2.64373C7.74092 2.564 7.86425 2.52325 7.98977 2.52942C8.1153 2.53558 8.23405 2.58822 8.32291 2.67709C8.41178 2.76595 8.46442 2.8847 8.47058 3.01023C8.47675 3.13575 8.436 3.25908 8.35627 3.35623L3.70627 7.99998L8.35627 12.6437C8.45016 12.7385 8.50283 12.8666 8.50283 13C8.50283 13.1334 8.45016 13.2614 8.35627 13.3562ZM7.64377 7.64373C7.55136 7.7393 7.4997 7.86704 7.4997 7.99998C7.4997 8.13292 7.55136 8.26066 7.64377 8.35623L12.6438 13.3562C12.7409 13.436 12.8643 13.4767 12.9898 13.4705C13.1153 13.4644 13.234 13.4117 13.3229 13.3229C13.4118 13.234 13.4644 13.1153 13.4706 12.9897C13.4767 12.8642 13.436 12.7409 13.3563 12.6437L8.70627 7.99998L13.3563 3.35623C13.436 3.25908 13.4767 3.13575 13.4706 3.01023C13.4644 2.8847 13.4118 2.76595 13.3229 2.67709C13.234 2.58822 13.1153 2.53558 12.9898 2.52942C12.8642 2.52325 12.7409 2.564 12.6438 2.64373L7.64377 7.64373Z" fill="#8B8B8B"/>
                                        </svg>}
                                        prevPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.50002 7.99998C4.50182 7.86746 4.55309 7.74039 4.64377 7.64373L9.64377 2.64373C9.74092 2.564 9.86425 2.52325 9.98977 2.52942C10.1153 2.53558 10.234 2.58822 10.3229 2.67709C10.4118 2.76595 10.4644 2.8847 10.4706 3.01023C10.4767 3.13575 10.436 3.25908 10.3563 3.35623L5.70627 7.99998L10.3563 12.6437C10.436 12.7409 10.4767 12.8642 10.4706 12.9897C10.4644 13.1153 10.4118 13.234 10.3229 13.3229C10.234 13.4117 10.1153 13.4644 9.98977 13.4705C9.86425 13.4767 9.74092 13.436 9.64377 13.3562L4.64377 8.35623C4.55309 8.25957 4.50182 8.1325 4.50002 7.99998Z" fill="#8B8B8B"/>
                                        </svg>}
                                        nextPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.5 8.00002C11.4982 8.13254 11.4469 8.25961 11.3562 8.35627L6.35623 13.3563C6.25908 13.436 6.13575 13.4767 6.01023 13.4706C5.8847 13.4644 5.76595 13.4118 5.67709 13.3229C5.58822 13.234 5.53558 13.1153 5.52942 12.9898C5.52325 12.8642 5.564 12.7409 5.64373 12.6438L10.2937 8.00002L5.64373 3.35627C5.564 3.25912 5.52325 3.13579 5.52942 3.01026C5.53558 2.88474 5.58822 2.76599 5.67709 2.67712C5.76596 2.58826 5.8847 2.53562 6.01023 2.52946C6.13575 2.52329 6.25908 2.56404 6.35623 2.64377L11.3562 7.64377C11.4469 7.74043 11.4982 7.8675 11.5 8.00002Z" fill="#8B8B8B"/>
                                        </svg>}
                                        lastPageText={<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.64373 2.64377C7.73853 2.54988 7.86656 2.49721 7.99998 2.49721C8.1334 2.49721 8.26143 2.54988 8.35623 2.64377L13.3562 7.64377C13.4486 7.73934 13.5003 7.86708 13.5003 8.00002C13.5003 8.13296 13.4486 8.2607 13.3562 8.35627L8.35623 13.3563C8.25908 13.436 8.13575 13.4767 8.01023 13.4706C7.8847 13.4644 7.76595 13.4118 7.67709 13.3229C7.58822 13.234 7.53558 13.1153 7.52942 12.9898C7.52325 12.8642 7.564 12.7409 7.64373 12.6438L12.2937 8.00002L7.64373 3.35627C7.54984 3.26147 7.49717 3.13344 7.49717 3.00002C7.49717 2.8666 7.54984 2.73857 7.64373 2.64377ZM8.35623 8.35627C8.44864 8.2607 8.5003 8.13296 8.5003 8.00002C8.5003 7.86708 8.44864 7.73934 8.35623 7.64377L3.35623 2.64377C3.25908 2.56404 3.13575 2.52329 3.01022 2.52946C2.8847 2.53562 2.76595 2.58826 2.67709 2.67712C2.58822 2.76599 2.53558 2.88474 2.52942 3.01026C2.52325 3.13579 2.564 3.25912 2.64373 3.35627L7.29373 8.00002L2.64373 12.6438C2.564 12.7409 2.52325 12.8642 2.52942 12.9898C2.53558 13.1153 2.58822 13.234 2.67709 13.3229C2.76595 13.4118 2.8847 13.4644 3.01023 13.4706C3.13575 13.4767 3.25908 13.436 3.35623 13.3563L8.35623 8.35627Z" fill="#8B8B8B"/>
                                        </svg>}
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={this.state.row_cnt}
                                        totalItemsCount={this.state.totalCnt}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                    />
                                </div>
                                : null
                            }
                            <div className="warning_del_rp_setting">
                                {/* <p><i className="fa fa-exclamation-circle" aria-hidden="true"></i>&nbsp;결제이용중인 진열은 삭제할 수 없습니다.</p> */}
                            </div>
                        </section>
                    </div>
                </div>
                {
					(this.state.confirm_dialog_show_state === true)
					? <ConfirmDialogV2
						content={this.state.confirm_dialog_content}
						button_list={this.state.confirm_dialog_button_list}
						popup_close={() => {
                            this.setState({confirm_dialog_show_state: false});
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
					: ''
				}
                {
					(this.state.basic_dialog_show_state === true)
					? <BasicDialogV2
						content={this.state.basic_dialog_content}
						button_list={this.state.basic_dialog_button_list}
					/>
					: ''
				}
                {
                    (this.state.delete_dialog_show_state === true)
                        ? <ConfirmDialogV2
                            content={this.state.delete_dialog_content}
                            button_list={this.state.delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_period_title_content_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            title={ this.state.is_finish == 0 ? this.state.remain_date+"일 뒤 "+this.state.payment_cls_text+"이 종료됩니다. <br/> 기간을 연장하시겠습니까?" : this.state.payment_cls_text+"이 종료되었습니다. <br/> 기간을 연장하시겠습니까?" }
                            content={this.state.payment_cls_text + " 기간<br/>" +  this.state.start_date_format + " ~ " + this.state.end_date_format}
                            button_list={this.state.title_content_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_period_title_content_dialog_show_state: false});
                            }}
                        />
                        : ''
                }
                {
                    (this.state.notice_delete_dialog_show_state === true)
                        ? <TitleContentDialogV2
                            content={this.state.notice_delete_dialog_content}
                            button_list={this.state.notice_delete_dialog_button_list}
                            popup_close={() => {
                                this.setState({notice_delete_dialog_show_state: false});
                                StyleUtil.clearPopupNoneScroll(window_scrollTop);
                            }}
                        />
                        : ''
                }
                {/* {this.state.tutorial_dialog_state &&
					<TitleContentDialogV2
						title={"로보MD 진열 사용하러 가볼까요?"}
						content={"다양한 자동 진열기능을 사용해 보시고<br/>자동 진열되는 상품결과를 미리보고 체험하세요."}
						button_list={[
                            {
                                title: "진열기능보기",
                                type: "1",
                                event_method: () => {
                                    this.addMainList();
                                    //팝업 닫기
                                    this.setState({
                                        tutorial_dialog_state: false,
                                        notice_period_title_content_dialog_show_state : false,
                                    });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            },
                            {
                                title: "닫기",
                                type: "0",
                                event_method: () => {
                                    //팝업 닫기
                                    this.setState({ tutorial_dialog_state: false });
                                    StyleUtil.clearPopupNoneScroll(window_scrollTop);
                                }
                            }
                        ]}
                        popup_close={() => {
                            this.setState({ tutorial_dialog_state: false });
                            StyleUtil.clearPopupNoneScroll(window_scrollTop);
                        }}
					/>
				} */}

                {this.state.showClonePopup &&
                <RpCafe24ClonePopup
                    org_event_setting_obj={this.state.targetCloneObj}
                    onClose={() => this.setState({ showClonePopup: false, targetCloneObj: null })}
                    loadRpEventEventSetting={() => this.loadRpEventEventSetting()}
                />
                }
            </>
        )
    };
    
}